/* eslint-disable no-unused-vars */
import { useLazyQuery, useMutation } from "@apollo/client";
import { useState } from "react";
import {
  APPLICANTS_BY_ORG,
  DASHBOARD_NOTIFICATION_ALL,
  GET_ANNIVERSARY,
  GET_BIRTHDAYS,
  GET_JOB,
  GET_JOBS,
  GET_NOTIFICATION_BY_ID,
  GET_NOTIFICATION_BY_LATEST,
  GET_PLACEMENT_BY_ORG,
  UPDATE_NOTIFICATION,
  UPDATE_PLACEMENT,
  UPDATE_JOB,
  UPDATE_PERSONALAPPLICANT,
  UPDATE_NOTIFICATION_SCHEDULE,
  UPDATE_CLIENT,
  UPDATE_VENDOR,
  UPDATE_ASSIGNED_SHIFT,
  UPDATE_CLAIM,
  UPDATE_MEDICALCLAIM,
  UPDATE_SURVEY,
  UPDATE_TASK,
  UPDATE_SUB_VENDOR,
} from "../../../src/core/services/mutations/index";
import { useSelector } from "react-redux";
import { useErrorsLog } from "../ErrorsLog/useerrorsLog";
const useDashBoard = ({ orgId, userId, Id }) => {
  const { createErrorLog } = useErrorsLog();
  const user = useSelector((state) => state.user.userData);
  const [selectDashBoardData, setDashBoardData] = useState({});
  const [
    getAnniversary,
    { loading: AnniversaryLoading, data: AnniversaryData },
  ] = useLazyQuery(GET_ANNIVERSARY, {
    variables: {
      orgId,
    },
    onError: (error) => {
      createErrorLog(error, "getAnniversary", user.userId, user.orgId);
    },
  });
  const [getBirthdays, { loading: BirthdaysLoading, data: BirthdaysData }] =
    useLazyQuery(GET_BIRTHDAYS, {
      variables: {
        orgId,
      },
      onError: (error) => {
        createErrorLog(error, "getBirthdays", user.userId, user.orgId);
      },
    });

  const [getPlacement, { loading: PlacementLoading, data: PlacementData }] =
    useLazyQuery(GET_PLACEMENT_BY_ORG, {
      variables: {
        orgId,
      },
      onError: (error) => {
        createErrorLog(error, "getPlacement", user.userId, user.orgId);
      },
    });
  const [getNotificationorglatest, { data: getNotificationorglatestdata }] =
    useLazyQuery(GET_NOTIFICATION_BY_LATEST, {
      fetchPolicy: "network-only",
      variables: {
        orgId: orgId,
        userId,
      },
      onError: (error) => {
        createErrorLog(
          error,
          "getNotificationorglatest",
          user.userId,
          user.orgId
        );
      },
    });
  const [getNotificationall, { loading:NotificationLoading, data: Notificationalldata }] = useLazyQuery(
    DASHBOARD_NOTIFICATION_ALL,
    {
      fetchPolicy: "network-only",
      variables: {
        orgId: orgId,
        userId,
      },
      onError: (error) => {
        createErrorLog(error, "getNotificationall", user.userId, user.orgId);
      },
    }
  );

  const [getNotificationById, { data: NotificationdatabyId }] = useLazyQuery(
    GET_NOTIFICATION_BY_ID,
    {
      fetchPolicy: "network-only",
      onError: (error) => {
        createErrorLog(error, "getNotificationById", user.userId, user.orgId);
      },
    }
  );

  const [getJobsByOrg, { data: jobsdata }] = useLazyQuery(GET_JOBS, {
    refetchQueries: [
      { query: GET_JOBS, variables: { orgId: 1 } }, // DocumentNode object parsed with gql
    ],
    onError: (error) => {
      createErrorLog(error, "getJobsByOrg", user.userId, user.orgId);
    },
  });
  const renderDashBoardData = (selectDashBoardData = {}) => {
    setDashBoardData();
  };

  const [getApplicantsByOrg, { data: applicantData }] = useLazyQuery(
    APPLICANTS_BY_ORG,
    {
      refetchQueries: [
        { query: APPLICANTS_BY_ORG, variables: { orgId: orgId } }, // DocumentNode object parsed with gql
      ],
      onError: (error) => {
        createErrorLog(error, "getApplicantsByOrg", user.userId, user.orgId);
      },
    }
  );

  const [updatenotification] = useMutation(UPDATE_NOTIFICATION, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatenotification", user.userId, user.orgId);
    },
  });

  const [updatePlacement] = useMutation(UPDATE_PLACEMENT, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      { query: GET_PLACEMENT_BY_ORG, variables: { orgId: orgId } }, // DocumentNode object parsed with gql
    ],
    onError: (error) => {
      createErrorLog(error, "updatePlacement", user.userId, user.orgId);
    },
  });
  const [updatedJob] = useMutation(UPDATE_JOB, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatedJob", user.userId, user.orgId);
    },
  });

  const [updatedapplicant] = useMutation(UPDATE_PERSONALAPPLICANT, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatedapplicant", user.userId, user.orgId);
    },
  });
  const [updateinterview] = useMutation(UPDATE_NOTIFICATION_SCHEDULE, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updateinterview", user.userId, user.orgId);
    },
  });
  const [updateclient] = useMutation(UPDATE_CLIENT, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updateclient", user.userId, user.orgId);
    },
  });
  const [updatevendor] = useMutation(UPDATE_VENDOR, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatevendor", user.userId, user.orgId);
    },
  });
  const [updateshift] = useMutation(UPDATE_ASSIGNED_SHIFT, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updateclient", user.userId, user.orgId);
    },
  });
  const [updateclaim] = useMutation(UPDATE_CLAIM, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updateclaim", user.userId, user.orgId);
    },
  });
  const [updatemedicalclaim] = useMutation(UPDATE_MEDICALCLAIM, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updateclaim", user.userId, user.orgId);
    },
  });

  const [updatesurvey] = useMutation(UPDATE_SURVEY, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatesurvey", user.userId, user.orgId);
    },
  });
  const [updatetask] = useMutation(UPDATE_TASK, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatetask", user.userId, user.orgId);
    },
  });
  const [updatesubvendor] = useMutation(UPDATE_SUB_VENDOR, {
    fetchPolicy: "network-only", // Doesn't check cache before making a network request
    refetchQueries: [
      {
        query: DASHBOARD_NOTIFICATION_ALL,
        variables: {
          orgId: orgId,
          userId,
        },
      },
    ],
    onError: (error) => {
      createErrorLog(error, "updatetask", user.userId, user.orgId);
    },
  });
  const [getJobByJobId, { loading: JobByJobId, data: jobData }] = useLazyQuery(
    GET_JOB,
    {
      fetchPolicy: "network-only",
      onError: (error) => {
        createErrorLog(error, "getJobByJobId", user.userId, user.orgId);
      },
    }
  );
  return {
    renderDashBoardData,
    getAnniversary,
    AnniversaryData,
    getBirthdays,
    BirthdaysData,
    PlacementData,
    getPlacement,
    getNotificationorglatest,
    getNotificationorglatestdata,
    selectDashBoardData,
    getJobsByOrg,
    jobsdata,
    applicantData,
    getApplicantsByOrg,
    getJobByJobId,
    jobData,
    getNotificationall,
    Notificationalldata,
    updatenotification,
    getNotificationById,
    NotificationdatabyId,
    updatePlacement,
    updatedJob,
    updatedapplicant,
    updateinterview,
    updateclient,
    updatevendor,
    updateshift,
    updateclaim,
    updatemedicalclaim,
    updatesurvey,
    updatetask,
    updatesubvendor,
    loading:NotificationLoading,
    
  };
};

export default useDashBoard;
